export const ActionTypes = {
  SET_URL:'SET_URL',
  SET_CONTENT:'SET_CONTENT'
};
